module.exports = __webpack_public_path__ + "img/personal-counter-dropdown-video-firsthalftreeplanted.93613ab.png";